import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/** @type {import('./budgetManagement.types').BudgetManagementSlice} */
export const initialBudgetManagementState = {
  status: 'idle',
  errors: [],
  data: null
}

/** @enum {string} */
export const BUDGET_MANAGEMENT_ACTIONS = {
  SET_BUDGET_MANAGEMENT_STATUS: 'SET_BUDGET_MANAGEMENT_STATUS',
  SET_BUDGET_MANAGEMENT_ERRORS: 'SET_BUDGET_MANAGEMENT_ERRORS',
  SET_BUDGET_MANAGEMENT_DATA: 'SET_BUDGET_MANAGEMENT_DATA',
  CLEAR_BUDGET_MANAGEMENT: 'CLEAR_BUDGET_MANAGEMENT'
}

export const budgetManagementSlicePropType = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  data: PropTypes.object
})
